var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppdevelopmenticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 43,
    viewBox: "0 0 26 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_114_1266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_114_1266",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 43
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_5358_566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H25.21V42.03H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_114_1266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.56C0 1.037 1.404 0 2.88 0H22.24C23.716 0 25.12 1.037 25.12 2.56V35.297L0 35.383V2.56ZM2.88 1.5C1.996 1.5 1.5 2.083 1.5 2.56V33.877L23.62 33.802V2.56C23.62 2.083 23.124 1.5 22.24 1.5H2.88Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.1003 41.91L2.21031 42.03C1.04031 42.03 0.0803125 41.15 0.0703125 40.04V35.38L25.1903 35.29L25.2203 39.89C25.2203 40.99 24.2803 41.9 23.1103 41.9L23.1003 41.91Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.9002 40.332C12.3405 40.332 12.7627 40.1571 13.074 39.8458C13.3853 39.5345 13.5602 39.1122 13.5602 38.672C13.5602 38.2317 13.3853 37.8095 13.074 37.4982C12.7627 37.1869 12.3405 37.012 11.9002 37.012C11.46 37.012 11.0377 37.1869 10.7264 37.4982C10.4151 37.8095 10.2402 38.2317 10.2402 38.672C10.2402 39.1122 10.4151 39.5345 10.7264 39.8458C11.0377 40.1571 11.46 40.332 11.9002 40.332Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.93 7.75H1V6.25H24.93V7.75Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50024 4C9.50024 3.86739 9.55292 3.74021 9.64668 3.64645C9.74045 3.55268 9.86763 3.5 10.0002 3.5H16.0002C16.1328 3.5 16.26 3.55268 16.3538 3.64645C16.4476 3.74021 16.5002 3.86739 16.5002 4C16.5002 4.13261 16.4476 4.25979 16.3538 4.35355C16.26 4.44732 16.1328 4.5 16.0002 4.5H10.0002C9.86763 4.5 9.74045 4.44732 9.64668 4.35355C9.55292 4.25979 9.50024 4.13261 9.50024 4ZM8.79424 17.225C8.88797 17.3188 8.94063 17.4459 8.94063 17.5785C8.94063 17.7111 8.88797 17.8382 8.79424 17.932L6.54724 20.178L8.79424 22.425C8.88799 22.5189 8.94061 22.6462 8.94052 22.7789C8.94042 22.9115 8.88762 23.0387 8.79374 23.1325C8.69985 23.2263 8.57257 23.2789 8.43988 23.2788C8.3072 23.2787 8.17999 23.2259 8.08624 23.132L5.48624 20.532C5.3925 20.4382 5.33984 20.3111 5.33984 20.1785C5.33984 20.0459 5.3925 19.9188 5.48624 19.825L8.08624 17.225C8.13268 17.1784 8.18786 17.1415 8.2486 17.1163C8.30935 17.0911 8.37447 17.0781 8.44024 17.0781C8.506 17.0781 8.57113 17.0911 8.63187 17.1163C8.69262 17.1415 8.74779 17.1784 8.79424 17.225ZM16.1772 17.224C16.2711 17.1304 16.3984 17.0779 16.5309 17.0781C16.6635 17.0783 16.7906 17.1311 16.8842 17.225L19.4742 19.825C19.5677 19.9187 19.6201 20.0457 19.6201 20.178C19.6201 20.3103 19.5677 20.4373 19.4742 20.531L16.8842 23.131C16.7901 23.2222 16.6638 23.2728 16.5327 23.2719C16.4016 23.2709 16.2761 23.2185 16.1833 23.1259C16.0905 23.0333 16.0377 22.908 16.0364 22.7769C16.0351 22.6458 16.0853 22.5194 16.1762 22.425L18.4142 20.178L16.1762 17.931C16.0826 17.8371 16.0302 17.7099 16.0303 17.5773C16.0305 17.4447 16.0834 17.3176 16.1772 17.224ZM14.1182 16.59C14.2373 16.6478 14.3286 16.7505 14.3721 16.8755C14.4156 17.0006 14.4077 17.1378 14.3502 17.257L11.3002 23.547C11.2716 23.6061 11.2316 23.659 11.1826 23.7026C11.1335 23.7463 11.0763 23.7798 11.0143 23.8013C10.9523 23.8229 10.8866 23.832 10.821 23.8282C10.7555 23.8243 10.6913 23.8076 10.6322 23.779C10.5731 23.7504 10.5203 23.7104 10.4766 23.6613C10.433 23.6123 10.3994 23.5551 10.3779 23.493C10.3563 23.431 10.3472 23.3654 10.3511 23.2998C10.3549 23.2342 10.3716 23.1701 10.4002 23.111L13.4502 16.821C13.4789 16.7619 13.5188 16.709 13.5679 16.6654C13.617 16.6217 13.6742 16.5882 13.7362 16.5666C13.7982 16.5451 13.8639 16.536 13.9294 16.5398C13.995 16.5437 14.0591 16.5614 14.1182 16.59Z",
    fill: "#181818"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 43,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdevelopmenticon);
export default __webpack_public_path__ + "static/media/appdevelopmenticon.156fc79af4bf7a15623bae200f488394.svg";
export { ForwardRef as ReactComponent };